module.exports = __webpack_public_path__ + "img/6.cb594a9c.png";